import React from 'react'
import { Input, useNumberInput, Flex, Button } from '@chakra-ui/react'
import FieldWrapper from '../FieldWrapper'
import PropTypes from 'prop-types'

const NumberInputField = ({
  name,
  validate,
  isReadOnly,
  isRequired,
  label,
  helperMessage,
  numberInputProps,
  ...inputProps
}) => {
  return (
    <FieldWrapper
      name={name}
      validate={validate}
      isReadOnly={isReadOnly}
      isRequired={isRequired}
      label={label}
      helperMessage={helperMessage}
    >
      {({ field, helpers }) => (
        <NumberInputWithHelpers
          field={field}
          helpers={helpers}
          isReadOnly={isReadOnly}
          numberInputProps={numberInputProps}
          inputProps={inputProps}
        />
      )}
    </FieldWrapper>
  )
}

const NumberInputWithHelpers = ({
  field,
  helpers,
  isReadOnly,
  numberInputProps,
  inputProps
}) => {
  const regex = /[\+\-]/g
  const parse = (val) => val.replace(regex, '')

  const { getInputProps, getIncrementButtonProps, getDecrementButtonProps } =
    useNumberInput({
      defaultValue: field.value,
      isReadOnly,
      ...numberInputProps,
      ...inputProps,
      onChange: (value) => helpers.setValue(parse(value))
    })

  const inc = getIncrementButtonProps()
  const dec = getDecrementButtonProps()
  const numberInput = getInputProps(field)

  return (
    <Flex sx={{ gap: '0.5rem' }}>
      {!isReadOnly && (
        <Button border="1px" borderColor="gray.300" {...dec}>
          -
        </Button>
      )}
      <Input {...numberInput} {...inputProps} />
      {!isReadOnly && (
        <Button border="1px" borderColor="gray.300" {...inc}>
          +
        </Button>
      )}
    </Flex>
  )
}

NumberInputField.propTypes = {
  name: PropTypes.string.isRequired,
  validate: PropTypes.func,
  isReadOnly: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string,
  helperMessage: PropTypes.string,
  numberInputProps: PropTypes.object
}

NumberInputField.defaultProps = {
  numberInputProps: {
    step: 1,
    precision: 2
  }
}

export default NumberInputField
